'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { MarketPrompt, MarketImage } from './market-primitives';
import { U, MarketReveal, Xl } from './collection-animation';
import { Pu, q, Fu, Iu, EmailPreview, Lu } from './marketing-email';
import { ShowcaseIcon } from './scene-primitives';
import { ShowcaseSpinner } from './playback-controls';
export function ProductPage({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'flex flex-col gap-4'}>
      <MarketPrompt
        t={e}
        workflow={'Build Product Page Content'}
        brand={'aubrac'}
        prompt={`${U.ref} for our store`}
        doneAt={Pu}
        busy={'Building the product page'}
        result={'Product page ready'}
        meta={'3 decision blocks'}
      />
      <MarketReveal on={e >= q.frame} className={'mk-card overflow-hidden'}>
        <div
          className={
            'text-ink-3 flex h-9 items-center gap-2 border-b border-[var(--line)] px-3 text-[12px]'
          }
        >
          <ShowcaseIcon name={'store'} className={'size-4'} />
          <span className={'text-ink font-medium whitespace-nowrap'}>
            {translateShowcaseNode(showcaseCopy, 'Store preview')}
          </span>
          <span className={'truncate max-sm:hidden'}>
            {translateShowcaseNode(showcaseCopy, '\xB7 Women / Coats / ')}
            {translateShowcaseNode(showcaseCopy, U.product)}
          </span>
          <span
            className={
              'ml-auto shrink-0 rounded-full bg-[var(--state-wash)] px-2 py-0.5 text-[11px] leading-4 font-medium'
            }
          >
            {translateShowcaseNode(showcaseCopy, 'Draft')}
          </span>
        </div>
        <div
          className={
            'grid gap-5 p-4 sm:p-5 md:grid-cols-[220px_minmax(0,1fr)] lg:grid-cols-[250px_minmax(0,1fr)] lg:gap-7'
          }
          style={{
            background: Fu,
            color: Iu,
          }}
        >
          <EmailPreview t={e} />
          <div className={'flex min-w-0 flex-col gap-2'}>
            <MarketReveal
              on={e >= q.block - 200}
              className={
                'flex items-baseline justify-between gap-3 text-[12px]'
              }
              style={{
                color: Lu,
              }}
            >
              <span className={'mk-caps text-[10px]'}>
                {translateShowcaseNode(showcaseCopy, 'Why this coat dress')}
              </span>
              <span className={'max-sm:hidden'}>
                {translateShowcaseNode(
                  showcaseCopy,
                  'Each block answers one hesitation'
                )}
              </span>
            </MarketReveal>
            <ul
              className={'grid grid-cols-3 gap-2 sm:gap-3'}
              aria-label={translateShowcaseNode(
                showcaseCopy,
                'Decision blocks'
              )}
            >
              {translateShowcaseNode(
                showcaseCopy,
                Xl.map((t, n) => {
                  let r = q.block + n * q.blockStep,
                    i = e >= r + q.land;
                  return (
                    <MarketReveal
                      key={t.label}
                      as={'li'}
                      pop={!0}
                      on={e >= r}
                      className={'flex min-w-0 flex-col gap-1.5'}
                    >
                      <span
                        className={
                          'relative block aspect-[4/5] overflow-hidden rounded-[6px]'
                        }
                        style={{
                          background: '#EFEAE2',
                        }}
                      >
                        <span
                          className={'absolute inset-0 grid place-items-center'}
                          style={{
                            color: Lu,
                          }}
                        >
                          {translateShowcaseNode(
                            showcaseCopy,
                            i ? null : <ShowcaseSpinner className={'size-4'} />
                          )}
                        </span>
                        <MarketReveal
                          on={i}
                          pop={!0}
                          className={'absolute inset-0'}
                        >
                          <MarketImage
                            asset={t.asset}
                            alt={translateShowcaseNode(
                              showcaseCopy,
                              t.asset.alt
                            )}
                            className={'size-full'}
                          />
                        </MarketReveal>
                      </span>
                      <span
                        className={
                          'flex items-baseline gap-1.5 px-0.5 text-[12px] leading-4'
                        }
                      >
                        <span
                          className={'num'}
                          style={{
                            color: Lu,
                          }}
                        >
                          {translateShowcaseNode(
                            showcaseCopy,
                            String(n + 1).padStart(2, '0')
                          )}
                        </span>
                        <span className={'font-medium'}>
                          {translateShowcaseNode(showcaseCopy, t.label)}
                        </span>
                      </span>
                    </MarketReveal>
                  );
                })
              )}
            </ul>
          </div>
        </div>
      </MarketReveal>
    </div>
  );
}
export const Hu = {
  frame: 300,
  ready: 1700,
  play: 1900,
  files: 2100,
};
export const Uu = 15;
export const Wu = 5400;
export const Gu = Array.from(
  {
    length: 72,
  },
  (e, t) => {
    let n = t / 71,
      r = 0.35 + 0.65 * Math.sin(Math.PI * Math.min(1, n * 1.15)),
      i = 0.55 + 0.45 * Math.abs(Math.sin(t * 1.7) * Math.cos(t * 0.63));
    return Math.max(0.12, r * i);
  }
);
export const Ku = ['Maison Aubrac', U.idea, 'The coat dress.'];
export const qu = [
  {
    asset: U.kit.teaser,
    focus: '50% 32%',
  },
  {
    asset: U.kit.launch,
    focus: '50% 8%',
  },
  {
    asset: U.kit.detail,
    focus: '50% 55%',
  },
];
export const Ju = (e) => `0:${String(Math.min(Uu, e)).padStart(2, '0')}`;
export function AudioWaveform({ played: e, on: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let n = Gu.length * 4;
  return (
    <svg
      viewBox={`0 0 ${n} 40`}
      preserveAspectRatio={'none'}
      aria-hidden={!0}
      className={'mk-wave block h-10 w-full'}
    >
      {translateShowcaseNode(
        showcaseCopy,
        Gu.map((n, r) => {
          let i = Math.max(2, n * 36);
          return (
            <rect
              key={r}
              x={r * 4 + 0.75}
              y={20 - i / 2}
              width={2.5}
              height={i}
              rx={1.25}
              fill={r / Gu.length < e ? 'var(--foreground)' : 'var(--border)'}
              style={{
                transformBox: 'fill-box',
                transformOrigin: 'center',
                transform: t ? 'none' : 'scaleY(0.1)',
                transition: `transform 520ms var(--ease) ${t ? r * 7 : 0}ms, fill 160ms linear`,
              }}
            />
          );
        })
      )}
    </svg>
  );
}
